import React, { useState, useEffect, useContext, useRef } from "react";

import { Toolbar } from "primereact/toolbar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
// import { RadioButton } from "primereact/radiobutton";
import { InputText } from "primereact/inputtext";
// import { TabView, TabPanel } from "primereact/tabview";

import GlobalContext from "../../../isp._comun/iu/contexto/GlobalContext";

import Dialogo from "../../../isp._comun/iu/_principal/componentes/layouts/Dialogo";
import { ModosOp } from "../../../isp._comun/iu/_principal/constantesIuPrin";
import * as Action from "../../reductores/acciones/dispatch/_ActionsDispatch";
import VentanaZona from "../../reductores/ventanas/VentanaZona";

import { TipoZonaLabel, UnidadZonaLabel } from "./žconstantesIuLayoutZonas";
import ActionZonaSet from "../../reductores/acciones/ActionZonaSet";
import SetRowZonaSelected from "../../reductores/acciones/dispatch/SetRowZonaSelected";

const DialogoQueryZonasLayout = ({
    ventana,
    buscarZonasCommand,
    registrarZonaCommand,
    actualizarZonaCommand,
    eliminarZonaCommand,
    dispatchQ,
    estadoQ,
}) => {
    const [globalFilter, setGlobalFilter] = useState(null);
    const { eliminarVentana } = useContext(GlobalContext);
    // const { abrirVentana, eliminarVentana } = useContext(GlobalContext);
    // const isMounted = useRef(false);

    /*  useEffect(() => {
        if (isMounted.current) {
            buscarClientesAFacturar();
        } else {
            isMounted.current = true;
        }
    }, [estadoQ.flag.sensorDeAccionABuscar]); */
    const dtRef = useRef(null);

     useEffect(() => {
        if (dtRef.current && dtRef.current.el) {
            const scrollableContainer = dtRef.current.el.querySelector('.p-datatable-wrapper');
            if (scrollableContainer) {
                // Mueve el scroll al final
                scrollableContainer.scrollTop = scrollableContainer.scrollHeight;
            }
        }
    }, [estadoQ.flag.sensorMostrarFinalTabla]); // Asegúrate de ejecutarlo tras cargar los datos

    useEffect(() => {
        if (!estadoQ.flag.procesandoComandoCrear) {
            return;
        }

        registrarZonaCommand.ejecutar({});

        return () => {
            registrarZonaCommand.cancelar();
        };
    }, [estadoQ.flag.procesandoComandoCrear]);

    useEffect(() => {
        if (!estadoQ.flag.procesandoComandoUpdate) {
            return;
        }

        actualizarZonaCommand.ejecutar({});

        return () => {
            actualizarZonaCommand.cancelar();
        };
    }, [estadoQ.flag.procesandoComandoUpdate]);

    useEffect(() => {
        if (!estadoQ.flag.procesandoComandoEliminar) {
            return;
        }

        eliminarZonaCommand.ejecutar({});

        return () => {
            eliminarZonaCommand.cancelar();
        };
    }, [estadoQ.flag.procesandoComandoEliminar]);

    useEffect(() => {
        if (!estadoQ.flag.procesandoComandoBuscarAll) {
            return;
        }

        buscarZonasCommand.ejecutar({});

        return () => {
            buscarZonasCommand.cancelar();
        };
    // }, []);
    }, [estadoQ.flag.procesandoComandoBuscarAll]);

    /* const dobleClickEnFila = (eventoSyn) => {
        const nuevaVentana = VentanaZona.nuevaVentanaEnModoOk(eventoSyn.data.idZona);
        abrirVentana(nuevaVentana);
    }; */
    /* const clickEnFila = (eventoSyn) => {
        // const nuevaVentana = VentanaZona.nuevaVentanaEnModoOk(eventoSyn.data.idZona);
        // abrirVentana(nuevaVentana);
        
    };
 */
    const header = {
        elementoReact: <p className="p-2 bg-gradient-to-r from-purple-100">Lista de Zonas</p>,
        enProgreso: false,
        // enProgreso: estadoQ.flag.procesandoComando,
    };

    const footer = (
        <div>
            {/* <Button
                label={"  Buscar  "}
                icon="pi pi-search"
                onClick={(eventoSynDom) => {
                    dispatchQ(new BuscarZonas());
                    // buscarClientesAFacturar();
                    eventoSynDom.stopPropagation();
                }}
                loading={estadoQ.flag.procesandoComando}
                iconPos="left"
                className="whitespace-pre"
            /> */}
            <Button
                label="    OK    "
                icon="pi pi-check"
                onClick={(eventoSynDom) => {
                    eliminarVentana(ventana);
                    eventoSynDom.stopPropagation();
                }}
                disabled={estadoQ.flag.procesandoComando}
                className="whitespace-pre"
            />
            <Button
                label="Cancelar"
                icon="pi pi-times"
                onClick={(eventoSynDom) => {
                    eliminarVentana(ventana);
                    eventoSynDom.stopPropagation();
                }}
                disabled={estadoQ.flag.procesandoComando}
                // className="w-32"
            />
        </div>
    );

    const dialogo = (
        <Dialogo
            // visible={true}
            // // style={{ width: "50vw"}}
            // modal={false}
            // onHide={() => onClick("CERRAR_DIALOGO")}
            // onShow={onShow}
            // onClick={() => onClick("CLICK_PANEL")}
            // keepInViewport={false}
            // maskStyle={{ zIndex: posicionZ }}
            ventana={ventana}
            cabecera={header}
            pie={footer}
            estilo={{ width: "25rem", minHeight: "70vh", top: "10vh", margin: "0" }}
            posicionZ={ventana.posicionZ}
            modal={false}
        >
            <span className="p-input-icon-left mb-2 w-full">
                <i className="pi pi-search" />
                <InputText
                    type="search"
                    onInput={(e) => setGlobalFilter(e.target.value)}
                    placeholder="Buscar..."
                    className="rounded-none m-0 w-full"
                    disabled={estadoQ.flag.procesandoComando}
                />
            </span>
            <div className="flex">
                <DataTable
                    ref={dtRef}
                    dataKey="nombre"
                    value={estadoQ.output.domain.resultSet}
                    // paginator
                    // rows={8}
                    scrollHeight={"40vh"}
                    rowHover
                    showGridlines
                    stripedRows
                    size="small"
                    selectionMode="single"
                    // cellSelection
                    selection={estadoQ.input.domain.rowSelected}
                    // autoLayout={true}
                    // autoLayout
                    // autoLayout={false}
                    // responsiveLayout="stack"
                    // responsiveLayout="scroll"
                    globalFilter={globalFilter}
                    scrollable
                    scrollDirection="vertical"
                    emptyMessage="No se encontró Zonas."
                    // totalRecords={100}
                    // columnResizeMode="expand"
                    columnResizeMode="fit"
                    // resizableColumns
                    className="m-0 mr-1 p-0 border-1"
                    tableStyle={{ minHeight: "40vh", width: "90%" }}
                    // tableStyle={{ minHeight: "40vh", maxHeight: "40vh", width: "90%" }}
                    // style={{ minHeight: "40vh", maxHeight: "40vh", width: "90%" }}
                    // onRowDoubleClick={dobleClickEnFila}
                    // onRowClick={clickEnFila}
                    onRowClick={(e) => {
                        dispatchQ(new SetRowZonaSelected({index: e.index, rowSelected: e.data}));
                        // dispatchQ(new SetIdZonaSelected(e.index))
                    }}
                    loading={estadoQ.flag.procesandoComando}
                    /* onSelectionChange={(e) => {
                        console(e.value)
                    }} */
                    // header={headerLista}
                >
                    {/* <Column field="nombre" header={"Nombre"} className="p-0 m-0 w-11/12"></Column> */}
                    {/* <Column field="estado" header={"Estado"} className="p-0 m-0 w-1/12"></Column> */}
                    {/* <Column field="nombre" header={"Nombre"} className="p-0 m-0 w-11/12" style={{ width: "90%" }}></Column> */}
                    {/* <Column field="estado" header={"Estado"} className="p-0 m-0 w-1/12" style={{ width: "10%" }}></Column> */}
                    <Column
                        field="nombre"
                        header={"Nombre"}
                        className="p-0 m-0"
                        style={{ minWidth: "82%" }}
                    ></Column>
                    {/* <Column
                        field="estado"
                        header={"Estado"}
                        className="p-0 m-0"
                        style={{ minWidth: "10%" }}
                    ></Column> */}
                </DataTable>
                <div className="flex flex-col">
                    <Button
                        id="actualizarBusqueda"
                        icon="pi pi-refresh"
                        className="p-button-outlined p-button-secondary border-2 p-2 mr-1 max-h-10 w-full"
                        onClick={(eventoSynDom) => {
                            dispatchQ(new Action.BuscarZonas());
                            // dispatchQ(new Action.ActualizarZona());
                            eventoSynDom.stopPropagation();
                        }}
                        disabled={estadoQ.flag.procesandoComando}
                        loading={estadoQ.flag.procesandoComandoBuscarAll}
                    />

                    <Button
                        id="eliminarZona"
                        icon="pi pi-trash"
                        className="p-button-outlined p-button-danger border-2 p-2 max-h-10 w-full"
                        onClick={(eventoSynDom) => {
                            dispatchQ(new Action.BuscarZonas());
                            eventoSynDom.stopPropagation();
                        }}
                        disabled={estadoQ.flag.procesandoComando}
                    />
                </div>
            </div>

            <div id="InputAgregarEditar" className="mt-4 mb-4 w-full">
                <InputText
                    type="input"
                    placeholder="Escribe una zona nueva..."
                    className="rounded-none w-full"
                    value={estadoQ.input.domain.nombre}
                    onChange={(e) => dispatchQ(new ActionZonaSet("nombre", e.target.value))}
                    maxLength={40}
                    disabled={estadoQ.flag.procesandoComando}
                />
                <small
                    id=""
                    // className={"mb-1.5 block p-error"}
                    className={estadoQ.error.nomBlanc ? "mb-1.5 block p-error" : "hidden"}
                >
                    Se requiere un nombre de Zona.
                </small>
            </div>

            <div className="mb-4 flex flex-row">
                <Button
                    label="Agregar"
                    icon="pi pi-plus"
                    className="p-button-outlined p-button-secondary border-2 p-2 w-1/2 mr-1 mb-1"
                    onClick={(eventoSynDom) => {
                        dispatchQ(new Action.GuardarZona());
                        eventoSynDom.stopPropagation();
                    }}
                    disabled={estadoQ.flag.procesandoComando}
                    loading={estadoQ.flag.procesandoComandoCrear}
                />

                <Button
                    label="Editar"
                    icon="pi pi-pencil"
                    className="p-button-outlined p-button-secondary border-2 p-2 w-1/2 mb-1"
                    onClick={(eventoSynDom) => {
                        dispatchQ(new Action.ActualizarZona());
                        eventoSynDom.stopPropagation();
                    }}
                    disabled={
                        estadoQ.flag.procesandoComando || 
                        estadoQ.input.domain.rowSelected === null ||
                        estadoQ.input.domain.nombre == estadoQ.input.domain.rowSelected.nombre
                    }
                    loading={estadoQ.flag.procesandoComandoUpdate}
                />

                {/* <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={confirmDeleteSelected} disabled={!selectedProducts || !selectedProducts.length} /> */}
            </div>
            <hr></hr>
        </Dialogo>
    );

    return dialogo;
};

export default DialogoQueryZonasLayout;
